define('app/factories/customer_profile_factory',['app/setup', 'app/models/customer', 'app/models/customer_password',
  'app/views/customer_profile_view','app/views/customer_profile_password_view',
    'app/views/customer_profile_mobile_view', 'app/views/customer_profile_invite_friend'],
  function(takhfifan, Customer, CustomerPassword, customer_profile_view, CustomerProfilePasswordView, CustomerProfileMobileView) {
    var views=[];
    views.push(new takhfifan.CustomerProfileView({ model: new takhfifan.Customer() }));
    views.push(new takhfifan.CustomerProfilePasswordView({ model: new takhfifan.CustomerPassword() }));
    views.push(new takhfifan.CustomerProfileMobileView());
    views.push(new takhfifan.CustomerProfileInviteFriendView());
    return views;
});

